import tw, { GlobalStyles } from 'twin.macro'
import { Global } from '@emotion/react'

import all from '@/components/all-global'
import Meta from '@/components/meta'
import Header from '@/components/header'
import Footer from '@/components/footer'

export default function PageWrapper({
  children,
  seo = {},
  bodyTw = tw`bg-transparent`,
  headerNav = null,
  otherLocales = [],
  breadcrumb = [],
  darkMode = false,
}) {
  return (
    <>
      <Meta {...seo} otherLocales={otherLocales} breadcrumb={breadcrumb} darkMode={darkMode} />
      <GlobalStyles />
      <Global styles={all} />
      <Header headerNav={headerNav} />
      <main css={[bodyTw]}>{children}</main>
      <Footer
        showLinkSections={!headerNav || (headerNav as Queries.HeaderFragment).mainNavItems?.length > 0}
        otherLocales={otherLocales}
      />
    </>
  )
}
